'use strict';

var typography = {};

exports.__exports = typography;
//# sourceMappingURL=typography5.cjs.map
